import { Burger, Center } from "@mantine/core";
import { Link } from "react-router";
import { ROUTES } from "../../routes";
import type { SiteName } from "../../utils/enums";
import { SiteLogo } from "./SiteLogo";

interface Props {
  siteName: SiteName;
  url?: string;
  isAdminDashboardPage?: boolean;
  height?: number;
  navbarOpened?: boolean;
  navbarToggle?: () => void;
}

function Brand({
  siteName,
  url = ROUTES.productSelectPage,
  isAdminDashboardPage,
  height,
  navbarOpened,
  navbarToggle
}: Props) {
  return (
    <>
      <Center bg="secondary.0" h={height} visibleFrom="md">
        {isAdminDashboardPage ? (
          <a className="m-brand__logo-wrapper" href={url}>
            <SiteLogo siteName={siteName} useSecondaryImage />
          </a>
        ) : (
          <Link className="m-brand__logo-wrapper" to={url}>
            <SiteLogo siteName={siteName} useSecondaryImage />
          </Link>
        )}
      </Center>
      <Center bg="secondary.0" h={height} hiddenFrom="md">
        <Burger
          aria-label={
            navbarOpened ? "Navigation schließen" : "Navigation öffnen"
          }
          color="primary"
          opened={navbarOpened}
          onClick={navbarToggle}
        />
      </Center>
    </>
  );
}

export { Brand };
